import logger from '../log';
import KollectiveXHR from '../interceptor/KollectiveXHR';
import XhrLoader from './HlsJsLoaderFactory';

const log = logger.getLogger(__filename);

export function loaderFactory(binder) {
  const xhrFactory = () => {
    if (binder.shouldIntercept()) {
      log.debug('using KollectiveXHR for request');
      const opts = binder.getOptions() || {};
      return new KollectiveXHR(opts);
    }
    return new window.XMLHttpRequest();
  };
  return xhrConfig => {
    return new XhrLoader({ ...xhrConfig, xhrFactory });
  };
}

/**
 * Bind intercept to flowplayer instance through hls tech.
 *
 * @param {{}} player flowplayer player instance
 * @param {function} shouldIntercept function that returns true if intercept should happen
 * @param {function} getOptions function that returns the relavant peer manager
 * @returns {void}
 */
export default function bindFlowplayerToWebRTC(player, binder) {
  const loader = loaderFactory(binder);
  const playerOpts = player.opts;
  // check for fLoader or pLoader as they override loader
  // https://github.com/video-dev/hls.js/blob/master/docs/API.md#loader
  const hls = playerOpts.hls;
  if (hls && (hls.pLoader || hls.fLoader)) {
    log.warn(
      'There is either an Hls#pLoader or Hls#floader set. This will conflict with the kollective integration. Contact Kollective for questions.',
      playerOpts
    );
  }
  player.setOpts({ hls: { ...hls, loader } });
}
